import isEqual from 'lodash/isEqual';

import { PromptModelConfig } from '../../../redux/api/types/sylvanus/model';
import { FieldModelConfig } from '../fields/types';

export const compareFieldModelConfig = (
  config1: FieldModelConfig,
  config2: FieldModelConfig,
) => {
  const hasFiltersChanged = !isEqual(config1.query, config2.query);

  const hasInstructionsChanged = !isEqual(
    config1.instructions,
    config2.instructions,
  );

  return { hasFiltersChanged, hasInstructionsChanged };
};

export const compareConfig = (
  config1: PromptModelConfig,
  config2: PromptModelConfig,
) => {
  const hasFiltersChanged = !isEqual(config1.query, config2.query);

  const hasInstructionsChanged = !isEqual(
    config1.instructions,
    config2.instructions,
  );

  return { hasFiltersChanged, hasInstructionsChanged };
};
